import { AlertCircleIcon, BadgeCheckIcon, InfoIcon } from 'lucide-react'
import type { HTMLAttributes } from 'react'

import { cva } from '~/utils/classnames'

const alertStyle = cva({
  base: 'inline-flex flex-col gap-px rounded-md py-0.5 px-1 pr-1.5 text-xs font-medium w-fit',
  variants: {
    type: {
      info: 'bg-pop-up-bg text-pop-up-fg',
      'over-media': 'bg-under/20 text-highlight backdrop-blur-md',
      success: 'bg-positive/20 text-foreground border border-positive/20',
      warning: 'bg-warning/20 text-foreground border border-warning/20',
      error:
        'bg-destructive/20 text-foreground animate-shake border border-destructive/20',
    },
  },
  defaultVariants: {
    type: 'info',
  },
})

type AlertProps = HTMLAttributes<HTMLDivElement> & {
  type: 'info' | 'over-media' | 'success' | 'error' | 'warning'
  title: string
  description?: string
}

const Alert = ({
  className,
  type,
  title,
  description,
  children,
  ...props
}: AlertProps) => {
  return (
    <div role="alert" className={alertStyle({ type, className })} {...props}>
      <div className="flex items-center gap-1">
        {type === 'info' && <InfoIcon className="shrink-0" />}
        {type === 'error' && <AlertCircleIcon className="shrink-0" />}
        {type === 'warning' && <AlertCircleIcon className="shrink-0" />}
        {type === 'success' && <BadgeCheckIcon className="shrink-0" />}
        <span>{title}</span>
      </div>
      {description && <p className="opacity-64">{description}</p>}
    </div>
  )
}

export { Alert }
